"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const IdentifiersTooltip = () => (react_1.default.createElement(CustomToolTip_1.default, { type: '?', inverse: true, place: 'right', info: 'Music unique identifiers are alphanumeric codes designed to distinguish and manage various elements within the music industry, ensuring accurate identification, attribution, and tracking.' }));
exports.default = IdentifiersTooltip;
